<template>
  <!--    :showSearch="parameters.showSearch"-->
  <a-select
    v-model="changeValue"
    :showSearch="isShowSearch"
    optionFilterProp="label"
    :allowClear="parameters.clearable"
    :defaultValue="parameters.defaultValue"
    :class="{ 'show-placeholder': changeValue === '' }"
    :placeholder="parameters.placeholder"
    @focus="onfocus"
  >
    <template v-for="(item, index) in options">
      <a-select-option
        :key="`select_${index}`"
        :value="item.value"
        :label="item.label"
      >
        <span v-if="parameters.isSelectShowColor" :class="item.color"></span>
        {{ item.label }}
      </a-select-option>
    </template>
  </a-select>
</template>

<script>
import { DataEntryMixin } from "./mixins";
import { isMobile } from "@/utils/index";

export default {
  name: "SdSelect",
  mixins: [DataEntryMixin],
  data() {
    return {
      isShowSearch: true,
      options: [],
    };
  },
  computed: {
    // 是否可编辑
    isModify({ $props }) {
      return Boolean($props.field.isModify);
    },
    // options({ parameters }) {
    //   const sourceData = parameters.options || [];
    //   const options = [];
    //   // console.log(35, parameters)
    //   sourceData.forEach((item) => {
    //     if (item.isEnable) {
    //       options.push(item);
    //     }
    //   });
    //   return options;
    // },
  },
  watch: {
    value: {
      handler() {
        this.$emit("refreshForm"); // 报考自定义关联业务
      },
    },
  },
  created() {
    this.isShowSearch = isMobile() ? false : true;
    // console.log('isMobile',isMobile(),'isShowSearch',this.isShowSearch)
    this.options = [...this.parameters.options];
    console.log("过滤前options", this.options);
  },
  methods: {
    onfocus() {
      this.options = [];
      this.options = this.parameters.options.filter((item) => item.isEnable);
      console.log("过滤后options", this.options);
    },
  },
};
</script>

<style lang="less">
.show-placeholder {
  .ant-select-selection__placeholder {
    display: inline-block !important;
  }
}
</style>
